import React from 'react';
import { Link } from 'react-router-dom';
import './PublicHomePage.css';

const PublicHomePage: React.FC = () => (
  <div className="public-admin-page">
    <section className="page-hero admin-public-hero">
      <div className="container">
        <span className="badge badge-navy">YOLO Admin</span>
        <h1>Operations & Commerce Control</h1>
        <p>
          Sign in to manage pricing rules, contracts, and site content. Use your IDP credentials
          to access the admin console.
        </p>
        <div className="admin-public-actions">
          <Link to="/login" className="btn btn-primary btn-lg">
            Sign in
          </Link>
          <Link to="/admin" className="btn btn-outline btn-lg">
            Open Console
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default PublicHomePage;
